import { createReducer, on } from '@ngrx/store';
import { Box } from '@app/store/placed-boxes/models';
import { unassignedBoxesActions } from '../actions/unassigned-boxes.actions';

export interface UnassignedBoxesState {
    boxes: Box[];
    page: number;
    hasMore: boolean;
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
}

export const initialState: UnassignedBoxesState = {
    boxes: [],
    page: 0,
    hasMore: false,
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
};

export const unassignedBoxesReducer = createReducer(
    initialState,
    // Load
    on(unassignedBoxesActions.loadBoxes, (state): UnassignedBoxesState => ({
        ...state,
        loading: true,
        loaded: null,
    })),
    on(unassignedBoxesActions.loadBoxesSuccess, (state, { payload, page, hasMore }): UnassignedBoxesState => ({
        ...state,
        loading: false,
        loaded: true,
        page,
        hasMore,
        boxes: page === 1 ? payload : [...state.boxes, ...payload.filter((box) => !state.boxes.some((item) => item.id === box.id))],
    })),
    on(unassignedBoxesActions.loadBoxesError, (state): UnassignedBoxesState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Generate
    on(unassignedBoxesActions.generateBoxes, (state): UnassignedBoxesState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(unassignedBoxesActions.generateBoxesSuccess, (state, { payload }): UnassignedBoxesState => ({
        ...state,
        saving: false,
        saved: true,
        boxes: [...state.boxes, ...payload],
    })),
    on(unassignedBoxesActions.generateBoxesError, (state): UnassignedBoxesState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Assign
    on(unassignedBoxesActions.assignBox, (state): UnassignedBoxesState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(unassignedBoxesActions.assignBoxSuccess, (state, { payload }): UnassignedBoxesState => ({
        ...state,
        saving: false,
        saved: true,
        boxes: state.boxes.filter((box) => box.id !== payload.id),
    })),
    on(unassignedBoxesActions.assignBoxError, (state): UnassignedBoxesState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Clear
    on(unassignedBoxesActions.clear, (): UnassignedBoxesState => ({ ...initialState })),
);
